ixModuleRouting("impactx.cscaccounting", {
    "/cscaccounting/:cscId/:preSetId?": {
        template: "<ixa-cscaccounting></ixa-cscaccounting>",
        templateUrl: "modules/cscaccounting/templates/cscaccounting.html",
        process: "EditCSCAccounting",
        controller: "CSCAccountingCtrl",
        controllerAs: "cscAccountingCtrl",
        workspace: "content",
    },
});
